import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { RemoveFromBlacklistRequest } from './removefromblacklistrequest';

export class RemoveFromBlacklistAPI extends SixdeeCRBTAPI<RemoveFromBlacklistRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/remove-from-black-list
        return "remove-from-black-list";
    }

    getRequestData()
    {
        return "clientTxnId=11092020"+"&"+
               "language="+ this.getRequest().getRemoveFromBlacklistRequest().getLanguage() +"&"+
               "aPartyMsisdn="+ this.getRequest().getRemoveFromBlacklistRequest().getAPartyMsisdn() +"&"+
               "channelId="+ this.getRequest().getRemoveFromBlacklistRequest().getChannelId() +"&"+
               "memberDetailList="+ JSON.stringify(this.getRequest().getRemoveFromBlacklistRequest().getMemberDetails());
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/blacklist/removefromblacklist/removefromblacklistapi.tsx